export enum LifePackageCode {
    Midi = 'midi',
    Maxi = 'maxi',
    Mini = 'mini',
    Free = 'free',
}
